import { Button, MenuItem } from "@mui/material";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import { Component } from "react";
import { connect } from "react-redux";

class PANGGIL_MENU extends Component {
  state = {
    anchor: null,
    modal_menu_card: false,
  };

  toggle_menu_card = (event) => {
    if (event) {
      this.setState({
        modal_menu_card: true,
        anchor: event?.currentTarget,
      });
    } else {
      this.setState({
        modal_menu_card: false,
        anchor: "",
      });
    }
  };

  render() {
    const { handleRefCol, focused } = this.props;
    const { anchor, modal_menu_card } = this.state;
    const modal_menu_card_content = (
      <FLOAT_MENU
        anchorEl={anchor}
        open={modal_menu_card}
        onClose={this.toggle_menu_card}
      >
        {
          <MenuItem disabled={focused ? false : true} onClick={handleRefCol}>
            Ref
          </MenuItem>
        }
      </FLOAT_MENU>
    );
    return (
      <main>
        <Button
          id="ref_button"
          onClick={this.toggle_menu_card}
          style={{ height: "40px", fontSize: "20px", width: "80px" }}
          variant="outlined"
        >
          {"</>"}
        </Button>
        {modal_menu_card_content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(PANGGIL_MENU);
